import {
  APPEND_KYB_DETAIL_ERROR_MESSAGES,
  DO_APPROVE_KYB,
  DO_REJECT_KYB,
  DO_SET_KYB_STATUS_PENDING,
  LOAD_KYB_BUSINESS_DETAIL,
  LOAD_KYB_BUSINESSES_LIST,
  SET_KYB_APPROVAL_LOGS,
  SET_KYB_APPROVE_CONFIRM_MODAL_LOADING,
  SET_KYB_APPROVE_CONFIRM_MODAL_SHOWN,
  SET_KYB_BUSINESS_DETAIL_LOADING_STATE,
  SET_KYB_BUSINESSES_LIST,
  SET_KYB_DETAIL_BANK_ACCOUNT,
  SET_KYB_DETAIL_BUSINESS_DETAILS,
  SET_KYB_DETAIL_ERROR_MESSAGES,
  SET_KYB_DETAIL_KTP_DETAILS,
  SET_KYB_DETAIL_MODAL_SHOWN,
  SET_KYB_EDIT_BANK_ACCOUNT_MODAL_LOADING,
  SET_KYB_EDIT_BANK_ACCOUNT_MODAL_SHOWN,
  SET_KYB_EDIT_KTP_MODAL_LOADING,
  SET_KYB_EDIT_KTP_MODAL_SHOWN,
  SET_KYB_LIST_FILTERS,
  SET_KYB_LIST_IS_LOADING,
  SET_KYB_REJECT_CONFIRM_MODAL_LOADING,
  SET_KYB_REJECT_CONFIRM_MODAL_SHOWN,
  SET_KYB_REVIEW_DETAILS_MODAL_LOADING,
  SET_KYB_REVIEW_DETAILS_MODAL_SHOWN,
  SUBMIT_KYB_EDIT_BANK_ACCOUNT,
  SUBMIT_KYB_EDIT_KTP,
} from 'state/actionTypes';

export const loadKybBusinessesList = (filters, paging) => ({
  type: LOAD_KYB_BUSINESSES_LIST,
  payload: {
    filters,
    paging,
  },
});

export const setKybListIsLoading = isLoading => ({
  type: SET_KYB_LIST_IS_LOADING,
  payload: isLoading,
});

export const setKybBusinessesList = (list, { page, size, total }) => ({
  type: SET_KYB_BUSINESSES_LIST,
  payload: { list, page, size, total },
});

export const setKybListFilters = ({
  startCreatedDate,
  endCreatedDate,
  kybStatus,
  searchKeyword,
  isKybRegistrationCompleted,
}) => ({
  type: SET_KYB_LIST_FILTERS,
  payload: {
    startCreatedDate,
    endCreatedDate,
    kybStatus,
    searchKeyword,
    isKybRegistrationCompleted,
  },
});

export const setKybDetailModalShown = shown => ({
  type: SET_KYB_DETAIL_MODAL_SHOWN,
  payload: shown,
});

export const loadKybBusinessDetail = businessId => ({
  type: LOAD_KYB_BUSINESS_DETAIL,
  payload: { businessId },
});

export const setKybDetailBusinessDetails = business => ({
  type: SET_KYB_DETAIL_BUSINESS_DETAILS,
  payload: { business },
});

export const appendKybDetailErrorMessages = messages => ({
  type: APPEND_KYB_DETAIL_ERROR_MESSAGES,
  payload: { messages },
});

export const appendKybDetailErrorMessage = message =>
  appendKybDetailErrorMessages([message]);

export const clearKybDetailErrorMessages = () => ({
  type: SET_KYB_DETAIL_ERROR_MESSAGES,
  payload: { messages: [] },
});

export const setKybBusinessDetailLoadingState = loadingStates => ({
  type: SET_KYB_BUSINESS_DETAIL_LOADING_STATE,
  payload: { loadingStates },
});

export const setKybDetailKtpDetails = ktp => ({
  type: SET_KYB_DETAIL_KTP_DETAILS,
  payload: { ktp },
});

export const setKybDetailBankAccount = bankAccount => ({
  type: SET_KYB_DETAIL_BANK_ACCOUNT,
  payload: { bankAccount },
});

export const setKybApproveConfirmModalShown = shown => ({
  type: SET_KYB_APPROVE_CONFIRM_MODAL_SHOWN,
  payload: { shown },
});

export const setKybApproveConfirmModalLoading = isLoading => ({
  type: SET_KYB_APPROVE_CONFIRM_MODAL_LOADING,
  payload: { isLoading },
});

export const doApproveKyb = businessId => ({
  type: DO_APPROVE_KYB,
  payload: { businessId },
});

export const doRejectKyb = (businessId, reason) => ({
  type: DO_REJECT_KYB,
  payload: { businessId, reason },
});

export const setKybApprovalLogs = approvalLogs => ({
  type: SET_KYB_APPROVAL_LOGS,
  payload: { approvalLogs },
});

export const clearKybApprovalLogs = () =>
  setKybApprovalLogs({ last_log: null, logs: [] });

export const setKybRejectConfirmModalShown = shown => ({
  type: SET_KYB_REJECT_CONFIRM_MODAL_SHOWN,
  payload: { shown },
});

export const setKybRejectConfirmModalLoading = isLoading => ({
  type: SET_KYB_REJECT_CONFIRM_MODAL_LOADING,
  payload: { isLoading },
});

export const setKybEditBankAccountModalShown = shown => ({
  type: SET_KYB_EDIT_BANK_ACCOUNT_MODAL_SHOWN,
  payload: { shown },
});

export const setKybEditBankAccountModalLoading = isLoading => ({
  type: SET_KYB_EDIT_BANK_ACCOUNT_MODAL_LOADING,
  payload: { isLoading },
});

export const submitKybEditBankAccount = (businessId, form) => ({
  type: SUBMIT_KYB_EDIT_BANK_ACCOUNT,
  payload: { businessId, form },
});

export const setKybReviewDetailsModalShown = shown => ({
  type: SET_KYB_REVIEW_DETAILS_MODAL_SHOWN,
  payload: { shown },
});

export const setKybReviewDetailsModalLoading = isLoading => ({
  type: SET_KYB_REVIEW_DETAILS_MODAL_LOADING,
  payload: { isLoading },
});

export const doSetKybStatusPending = businessId => ({
  type: DO_SET_KYB_STATUS_PENDING,
  payload: { businessId },
});

export const setKybEditKtpModalShown = shown => ({
  type: SET_KYB_EDIT_KTP_MODAL_SHOWN,
  payload: { shown },
});

export const setKybEditKtpModalLoading = isLoading => ({
  type: SET_KYB_EDIT_KTP_MODAL_LOADING,
  payload: { isLoading },
});

export const submitKybEditKtp = (businessId, form) => ({
  type: SUBMIT_KYB_EDIT_KTP,
  payload: { businessId, form },
});
